import { BoardStatusEnum, getBoardStatusLabel } from "enums/BoardStatusEnum";
import { NumberChoiceModel } from "models/ChoiceModel";
import { TranslationsContextProps } from "providers";

export function getBoardStatuses(i18n: TranslationsContextProps): NumberChoiceModel[] {
  return [BoardStatusEnum.Draft, BoardStatusEnum.Active, BoardStatusEnum.Archived, BoardStatusEnum.Deleted].map(
    (s) => ({
      name: BoardStatusEnum[s],
      text: getBoardStatusLabel(s, i18n),
      value: s,
      disabled: false,
    })
  );
}
